import {ChangeDetectionStrategy, Component, computed, contentChildren, input, InputSignal, Signal} from '@angular/core';
import {BasicSubscribableComponent} from '../dummy-components/basic-subscribable-component';
import {ActionItemComponent} from '../action-item/action-item.component';
import {TranslationKey} from '../../types/available-translations.type';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
    host: { '[class.visually-hidden]': 'this.hideClass()' },
    selector: 'app-action-item-group',
    templateUrl: './action-item-group.component.html',
    imports: [
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./action-item-group.component.css']
})
export class ActionItemGroupComponent extends BasicSubscribableComponent {
    public groupTitle: InputSignal<TranslationKey> = input.required<TranslationKey>();
    protected hideClass: Signal<boolean>;
    private readonly contentActionItems: Signal<ReadonlyArray<ActionItemComponent>> = contentChildren(ActionItemComponent, { descendants: true });

    public constructor() {
        super();
        this.hideClass = computed(() => this.contentActionItems().length === 0);
    }
}
